<input
  type="time"
  class="border-default bg-surface text-text-primary placeholder-text-tertiary focus:border-accent-focus focus:ring-accent-focus block w-full rounded-lg border p-2.5 text-sm"
  [value]="value()"
  [id]="id()"
  [min]="min()"
  [max]="max()"
  [required]="required()"
  (input)="onInput($event)"
  (blur)="onTouched()" />
